import { defineComponent as _defineComponent } from 'vue'
import DButton from '@/components/base/DButton.vue'
import { UUID } from '@Protium/vue-ozone-utils'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import Clipable from '@/components/Clipable.vue'

const ERROR__MAX_LENGTH = 'Tag too long (max 32 characters)'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderTags',
  props: {
    modelValue: { default: () => ([]) },
    orderId: {},
    exclude: {},
    summary: { type: Boolean }
  },
  emits: ['update:model-value', 'add', 'remove', 'edit'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const $store = useStore()
const $directr = $store.getters['Services/Directr']

const props = __props

const emit = __emit
const editing = ref(false)
const inputValue = ref<string>('')
const limitedInputValue = computed({
  get: () => {
    return inputValue.value
  },
  set: value => {
    if (value?.length > 32) {
      error.value = ERROR__MAX_LENGTH
      return
    }
    error.value = null
    inputValue.value = value
  }
})
const inputWidth = computed(() => `${Math.max(55, inputValue.value.length * 9)}px`)
const error = ref()

const tags = computed({
  get: () => {
    return !props.exclude?.length
      ? (props.modelValue || [])
      : (props.modelValue || []).filter(tag => !props.exclude?.includes(tag))
  },
  set: (value) => {
    emit('update:model-value', value)
  }
})

const summaryString = computed(() => {
  return tags.value?.length > 1 ? `#${(tags.value[0]?.length > 16 ? `${tags.value[0].substring(0,16)}...` : `${tags.value[0]}`)} +${tags.value?.length - 1}` : (tags.value[0]?.length > 16 ? `${tags.value[0].substring(0,16)}...` : `#${tags.value[0]}`)
})

function toggleEdit (value) {
  editing.value = value
}

function addTag (tag) {
  if (tag?.length > 32) {
    error.value = ERROR__MAX_LENGTH
    return
  }
  error.value = null
  inputValue.value = ''

  if (!props.orderId) throw Error('Missing order-id')
  toggleEdit(false)

  if (!props.modelValue) emit('update:model-value', [])
  const updated = (tags.value || []).concat(tag)

  $directr.order.patchTags(props.orderId, updated)
    .catch(e => {
      console.error('addTag error', e)
    }).finally(() => {
      toggleEdit(false)
    })

  emit('update:model-value', updated)
}
function removeTag (index) {
  const updated = tags.value
  if (updated?.length === 1) {
    emit('update:model-value', [])
    updated.length = 0
  } else {
    toggleEdit(true)
    updated.splice(index, 1)
  }
  if (index === updated.length - 1) toggleEdit(false)

  $directr.order.patchTags(props.orderId, updated)
    .catch(e => {
      console.error('listaction.deleteOrder error', e)
    }).finally(() => {
      toggleEdit(false)
    })

  emit('update:model-value', updated)
}

function validateTag (e) {
  if (e[0].label.length > 32) return false
  else return true
}

function cancel () {
  if (tags.value.length > (props.modelValue?.length || 0)) tags.value.pop()
  toggleEdit(false)
}

const __returned__ = { $store, $directr, ERROR__MAX_LENGTH, props, emit, editing, inputValue, limitedInputValue, inputWidth, error, tags, summaryString, toggleEdit, addTag, removeTag, validateTag, cancel, DButton, get UUID() { return UUID }, computed, ref, get useStore() { return useStore }, Clipable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})